import { FetchError } from './FetchError';
import { FETCH_TRANSFORMER_ERROR_CODE } from 'utils';

/**
 * Network-related errors (connection failures, timeouts, DNS errors)
 *
 * @example
 * ```typescript
 * throw new NetworkError(
 *   'Connection timeout',
 *   { url: 'https://api.example.com', timeout: 30000 },
 *   originalError
 * );
 * ```
 */
export class NetworkError extends FetchError {
  override readonly type = 'NetworkError';

  constructor(message: string, details?: Record<string, unknown>, cause?: Error) {
    super(message, FETCH_TRANSFORMER_ERROR_CODE.NETWORK_ERROR, undefined, details, cause);
  }
}
